import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import { v4 } from "uuid";
import { Col, Label, Row, Span } from "../../../Styleds";
import apiManager from './../../../ApiManager';
const Links = ({ addModalType, eventsId,links,set_links, onUpdate, add = false, editing = false, labelBg = "#E5E5E5" }) => {
    useEffect(() => {
        console.log("eventsId", eventsId);
        loadData();
    }, []);
    async function loadData() {
        const res = await apiManager.fetchGet(`event/${eventsId}/reference-links`, {}, 0);
        console.log("res", res)
        set_links(res);
    }
    return (
        <Col gap=".8rem">
            {
                links.map((v, k) => {
                    return <Row gap="1rem" key={k} align="flex-start">
                        {editing &&
                            <img src="./assets/ui/minus.png" onClick={e => {
                                addModalType({
                                    cls: "AlertCustom", arg: {
                                        title: "刪除此參考連結？",
                                        desc: "刪除後將無法復原。",
                                        options: [
                                            {
                                                label: "刪除", cb: () => {
                                                    console.log(eventsId, v);
                                                    apiManager.fetchDelete(`event/${eventsId}/reference-links/${v.event_reference_links_id}`).then(res => {
                                                        set_links(prev => prev.filter(obj => obj.event_reference_links_id !== v.event_reference_links_id))
                                                    }).catch(err => {
                                                        alert(err)
                                                    })
                                                }
                                            },
                                            {
                                                label: "取消", cb: () => {
                                                    console.log("ce")
                                                }
                                            },
                                        ],
                                    }
                                })
                            }} />
                        }
                        <Label style={{ padding: ".4rem .8rem", background: "#E5E5E5" }}>
                            <Row gap=".4rem" align="flex-start" onClick={e => {
                                window.open(v.event_reference_links_link, "_blank");
                            }}>
                                <img src="./assets/ui/link.png" />
                                <Span>{v.event_reference_links_title}</Span>
                                <img src="./assets/ui/upArrow.png" />
                            </Row>
                        </Label>
                    </Row>
                })
            }
            {(add && editing === false) &&
                <Label style={{ padding: ".4rem .8rem", background: "#E5E5E5" }}>
                    <Row gap=".4rem" align="flex-start" onClick={e => {
                        addModalType({
                            cls: "AddLink", arg: {
                                type: "rewilding",
                                cb: (linkObj) => {
                                    console.log("linkObj", linkObj);
                                    apiManager.fetchPost(`event/${eventsId}/reference-links`, {
                                        "event_reference_links_link": linkObj.url,
                                        "event_reference_links_title": linkObj.title
                                    }, 0).then(res => {
                                        set_links(prev => [...prev, res]);
                                    }).catch(err => {
                                        alert(err)
                                    })
                                }
                            }
                        })
                    }}>
                        <img src="./assets/ui/addLink.png" />
                        <Span>新增連結</Span>
                    </Row>
                </Label>
            }
        </Col>
    );

}

export default Links;